import {StandardProductManagerDatabase} from "../../databases/standard-product-manager.database";


export class SqlitePriceListV2Repository {

    constructor(private readonly standardProductManagerDatabase: StandardProductManagerDatabase) {}

    async getProductsPriceListForActiveVersion(priceListId: number): Promise<any> {
        const sql = `
            SELECT *
            FROM pricelist
            WHERE id = $id
            LIMIT 1
        `;

        const params = { "$id": priceListId };

        const result:any [] = await this.standardProductManagerDatabase.queryObjects(sql, params, ['productPricings']);

        if (result.length === 0) {
            return null;
        }

        return result[0];
    }


}
